import { Injectable } from '@angular/core';
import { DefaultAreaNotCoveredComponent } from './component/default-area-not-covered/default-area-not-covered.component';
import { HomehuntAreaNotCoveredComponent } from './component/homehunt-area-not-covered/homehunt-area-not-covered.component';

@Injectable({
  providedIn: 'root',
})
export class AreaNotCoveredService {
  constructor() {}
  getCompanyComponent(aliasName) {
    if (aliasName == 'homehunt') {
      return { data: null, component: HomehuntAreaNotCoveredComponent };
    } else return { data: null, component: DefaultAreaNotCoveredComponent };
  }
}
